<template>

<basic-content>
<div slot="content" style="text-align:left; padding: 20px 0px 20px 0px">
<p>爱助手App是由北京仝睿科技有限公司团队打造的一款企业大数据营销获客与行业分析的效率工具，以下是基于爱助手的功能对操作过程进行的简单介绍。</p>

<h2>一、获客与行业分析</h2> 	
<h3>1.搜索</h3>
	<p>如果需要找到某个企业，或尝试获取某个企业的详细信息，可以通过提供少量线索，如客户公司名称、产品业务、关键词，或者可以提供一小段业务描述等，在获客页面的输入框内输入并搜索，爱助手的智能搜索关联，将迅速帮助您锁定目标信息；</p>
	<p>也可在点击搜索框后，在出现的企业信息页面上方的工具栏中，找到筛选图标，通过地区（企业注册地址）、行业、形态（企业类型）、状态（是否在营）、注资、年限、联系（方式）等线索，进行锁定，从而精准迅捷的找到目标信息。</p>
	
<h3>2.关联</h3>
	<p>如果已知一个企业，需要找到与之相似或相关的企业，可以通过爱助手的“关联”功能实现。</p>
	<p>通过搜索，找到已知企业信息条目并勾选，将该条信息作为锚定，点击页面上方的关联工具，即可触发“找相关”功能，弹窗页面将确认锚定信息，并告知将查找与该锚定信息类似的企业，此时可对查找结果进行调整，如，在前一步勾选了多条企业，此时可根据需求进行多条锚定信息的删减，也可在弹窗页面下方的文本框内输入相应的关键词条件信息文本，即可对关联结果进行调整；</p>
	<p>确认“找相关”的锚定信息后，即可点击弹窗页面上方的对勾图标进行确认关联功能触发，爱助手即可找到目标结果信息，即与已知企业相关联的批量企业信息名录；</p>
	<p>利用爱助手关联工具，可助力开展营销客户池拓展、行业分析研究、市场调研、竞品分析等方面的专业工作。</p>

<h3>3.分析</h3>
	<p>针对通过搜索获得的批量企业信息名录，需要对改类目中的某几个企业进行数据分析比对，即可勾选参与数据分析比对的企业，如果需要对该类目下的全部企业进行数据对比分析，可先点击页面上方的全选工具进行全选，完成选择后，点击页面上方的数据分析图标，即可获取数据分析结果，改结果以图表的方式呈现，数据分析比对项包括：成立时间区间、注册地区集散、行业分类占比、注册资金范围图表，数据分析图表帮助全局视角直观比对数据，亦可截图直接将图表用于分析报告；</p>
	<p>爱助手分析工具，可应用于行业分析报告撰写、市场调研、营销者客户研究、了解行情等工作场景。</p>

<h3>4.标记数据</h3>
	<p>搜索到的企业，根据对其的研究或了解，可为其贴上某些特定的标签，点击页面上方的打标签工具，即可在“增加标签”页面，将该选中企业打上既有标签，点击选择一个标签（结构化树形标签需点击父级即可展开子级），再点击弹窗页面上方的确认对勾，即可完成对该企业的打标签操作。</p>
	<p>标记数据对了解企业、了解行业从而进一步进行分析研究工作来说是一个至关重要的过程，存在于某个企业信息上的标签，即可作为搜索、关联到该企业的线索，即，下次可利用此标签追踪到该企业，标记数据的过程，既是构建企业信息知识库的过程，利用标签树工具，即可直接准确追踪到特定企业。</p>

<h3>5.标签体系</h3>
	<p>若已经存在一标签，或存在体系化、结构化关系的标签组（这些标签可能是从改企业的属性、产品、业务等方向来定义的），需在获客助手页面进行标签树的添加与编辑，点击搜索框下方的添加，在“标签树编辑器”页面进行标签名文本输入或粘贴操作，仅需要处理文本即可，爱助手标签体系工具可自动生成结构化标签体系，并以直观标签树形式呈现，标签体系编辑规则为：每行一个标签，用缩紧表示标签之间存在的父子级关系，若需要对某个标签添加备注，即可在标签后键入“#”后输入注释，标签文本编辑完成后，点击页面上方对勾图标进行确认，即可见已生成好的标签树。</p>
	<p>标签体系工具支持实时标签树的编辑操作，对于已生成的标签树，可对需进行编辑操作的标签条，进行左滑手势操作，随即召唤出标签树工具栏，在工具栏中可见上传、标签名编辑、删除、添加子标签的图标，上传即为对该标签的数据进行批量上传，按照上传弹窗页面提示进行“字段”与“记录”的数据上传操作即可；编辑即为对该标签文本名称进行修改；对某标签进行删除操作，将会同时删除该标签级下的所有从属级标签；添加子标签亦可实时更新到标签树中。</p>
	<p>已生成出的标签树，支持实现用户间的共享，对某一标签树的标签名主题执行左滑操作，召唤出工具栏，点击标签名主题工具栏中的分享图标，即可以实现将标签树共享给其他用户，分享方式可以是“只读好友”、“可再分享好友”、“可修改好友”三种，在选定方式的输入框中输入对方用户哟用户的手机号并点击+，确认后点击弹窗页面下方的“确定”即可完成操作，成功分享给好友用户的标签树，即可为被分享者所见。</p>
	
<h2>二、热点内容搭载推广</h2>
<h3>1.为您工作中常用的标签组提供结构化可视系统</h3>
	<p>进入到推广页面后，点击页面右上方的添加图标，进入到推广编辑页面，点击页面上方的编辑图标，即可输入计划推广的文章主题，输入后点击确定，爱助手的推广工具即可寻索相关度高、匹配性佳的热点内容，此热点内容具有流量大的特点，因此将此类热点内容作为推广载体，推广效果客可观；</p>
	<p>如果并不能够输入推广主题，可以在推广助手页下方找到热点推广文库，根据相关的最热主题分类进行选择，爱助手将完成热文推荐的过程；</p>
	<p>如果不满意当前文章内容，可点击页面上方的左右翻页图标进行切换；</p>
	<p>完成文章的选取后，点击页面中心的添加图标，即可进行本地图片的上传操作；</p>
	<p>页面下方的推广信息栏目中，可点击小图更换成推广头像，点击推广主题可以重新设定输入主题，以及一句简短的宣传语，点击图标可分别添加推广信息，分别为“电话、微信（含微信号及二维码）以及网址三个信息项，添加好的推广信息，被分享者可直接点击相应的图标按钮与推广者进行联系，如点击电话图标按钮，将直接播出电话；</p>
	<p>完成推广内容的编辑与设定后，点击页面上方的分享图标即可完成分享操作，分享渠道支持微信与朋友圈推广传播；</p>
	<p>爱助手的推广工具搭载社交平台，实现社交资源向推广资源的转化，简化编辑内容的过程，搭载社交平台，推广效果直接了当。</p>

</div>
</basic-content>
</template>

<script>

import BasicContent from '@/layout/BasicContent.vue'

export default {
  name: 'Help',
  data() { 
    return { 
        tab: "uc,help",
        styleDef: "height:16px; width:16px; color:#F5F6F5;"
    }
  }, 

  props: {
  },

  components: { 
    BasicContent
  }, 

  methods: {
  },
  created() {
    this.$store.commit('changetab', this.tab);
  }
}
</script>

<style scoped>

</style>

